import React, { useEffect, useState } from "react"
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Row,
  Table,
} from "reactstrap"
import { Sparklines, SparklinesLine } from "react-sparklines"

import upArrow from "../../assets/images/icons/upArrow.svg"

import greenCheckIcon from "../../assets/images/icons/green-check-fill.svg"
import blueCheckIcon from "../../assets/images/icons/blue-checked-filled.svg"
import grayCheckIcon from "../../assets/images/icons/gray-cricel.svg"
import Clock from "../../assets/images/icons/clock-icon.svg"
import googleDocs from "../../assets/images/icons/google-docs.svg"
import inbox from "../../assets/images/icons/inbox.svg"
import building from "../../assets/images/icons/office-building.svg"
import VerifiedInvestor from "../../assets/images/verified-investor.png"

import { Link } from "react-router-dom"
import { useSelector } from "react-redux"
import {
  useLazyResolveQueryStepsQuery,
  useResolveQueryStepsQuery,
} from "store/api/kyc/kyc"
import Spinners from "components/Common/Spinner"

const ResolveQueryBox = () => {
  const [steps, setSteps] = useState([])
  const { data: querySteps, isFetching } = useResolveQueryStepsQuery()

  useEffect(() => {
    if (querySteps && querySteps?.data?.steps.length > 0) {
      let currentIndex = 0
      let currentStep = querySteps?.data?.current_step
      if (currentStep === "FINAL_STEP") {
        currentIndex = querySteps?.data?.steps.length
      } else if (currentStep === "BANK_DETAILS") {
        currentIndex = 3
      } else {
        currentIndex = querySteps?.data?.steps.findIndex(
          (step) => step.key && step.key.includes(currentStep)
        )
      }

      const updatedSteps = querySteps?.data?.steps.map((item, index) => {
        return {
          ...item,
          icon: index < currentIndex ? greenCheckIcon : grayCheckIcon,
        }
      })

      setSteps(updatedSteps)
    }
  }, [querySteps])

  return (
    <React.Fragment>
      <div className="start-investing-section d-flex flex-column justify-content-between">
        <div>
          <h2>Query Raised By Admin</h2>
          <h3>
            Please provide the required details to resolve the query and
            complete your KYC
          </h3>
          <div className="investor-steps-box-wrapper">
            {steps?.map((item, index) => (
              <React.Fragment key={`steps_${index}`}>
                <div className="step-section-inner-box">
                  <div className="step-section-title">
                    <img height={"20px"} src={item.icon} alt="" />
                    <h6
                      dangerouslySetInnerHTML={{
                        __html: item.label,
                      }}
                    ></h6>
                  </div>
                  <p>Step {index + 1}</p>
                </div>
              </React.Fragment>
            ))}
          </div>
        </div>
        <Link to={"/resolve-query"}>
          <Button className="btn btn-primary">
            {isFetching ? <Spinners /> : "Resolve KYC Query"}
          </Button>
        </Link>
      </div>
    </React.Fragment>
  )
}

export default ResolveQueryBox
